import Icon from '../components/Icon.vue'

Icon.register({
  'dice-six': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M384 32H64C28.6 32 0 60.6 0 96V416C0 451.4 28.6 480 64 480H384C419.4 480 448 451.4 448 416V96C448 60.6 419.4 32 384 32zM128 384C110.3 384 96 369.7 96 352S110.3 320 128 320 160 334.3 160 352 145.7 384 128 384zM128 288C110.3 288 96 273.7 96 256S110.3 224 128 224 160 238.3 160 256 145.7 288 128 288zM128 192C110.3 192 96 177.7 96 160S110.3 128 128 128 160 142.3 160 160 145.7 192 128 192zM320 384C302.3 384 288 369.7 288 352S302.3 320 320 320 352 334.3 352 352 337.7 384 320 384zM320 288C302.3 288 288 273.7 288 256S302.3 224 320 224 352 238.3 352 256 337.7 288 320 288zM320 192C302.3 192 288 177.7 288 160S302.3 128 320 128 352 142.3 352 160 337.7 192 320 192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-six.js
// module id = vOoN
// module chunks = 144